import { ActionType } from 'typesafe-actions';
import { ActionTypes } from './actionTypes';
import * as actions from './actions';
import { State, GestorTabla, FormadorTabla, AlumnoTabla } from './types';
import { RequestStatusTypes } from 'consts';

export const initialState: State = {
  // Alumnos
  alumnosCursos: [],
  alumnosCursosCount: 0,
  curso: null,

  // Cursos
  cursos: [],
  cursosCount: 0,
  sociedades: [],
  provincias: [],
  estados: [],
  cursosFilter: [],
  // Cursos cierre
  cursosCierre: [],
  cursosCierreCount: 0,
  sociedadesCursosCierres: [],
  provinciasCursosCierre: [],
  //panel administracion
  //gestores
  getAllGestoresRequestStatus: {
  status: RequestStatusTypes.Default,
  },
  gestoresAll: [] as GestorTabla[],
  insertarGestoresCursosRequestStatus: {
  status: RequestStatusTypes.Default,
  },

  eliminarGestoresCursosRequestStatus: {
  status: RequestStatusTypes.Default,
  },

  //formadores
  getAllFormadoresRequestStatus: {
  status: RequestStatusTypes.Default,
  },
  formadoresAll: [] as FormadorTabla[],
  insertarFormadoresCursosRequestStatus: {
  status: RequestStatusTypes.Default,
  },

  eliminarFormadoresCursosRequestStatus: {
  status: RequestStatusTypes.Default,
  },

  //alumnos
  getAllAlumnosRequestStatus: {
  status: RequestStatusTypes.Default,
  },
  alumnosAll: [] as AlumnoTabla[],
  insertarAlumnosCursosRequestStatus: {
  status: RequestStatusTypes.Default,
  },

  eliminarAlumnosCursosRequestStatus: {
  status: RequestStatusTypes.Default,
  },

  // caché
  allSociedades: [],
};

const reducer = (
  state: State = initialState,
  action: ActionType<typeof actions>
): State => {
  switch (action.type) {
    case ActionTypes.SET_ALUMNOS_CURSOS:
      // Alumnos
      return {
        ...state,
        alumnosCursos: action.payload,
      };
    case ActionTypes.SET_ALUMNOS_CURSOS_COUNT:
      return {
        ...state,
        alumnosCursosCount: action.payload,
      };
    case ActionTypes.SET_ALUMNOS_CURSO:
      return {
        ...state,
        curso: action.payload,
      };
    // Cursos
    case ActionTypes.SET_CURSOS:
      return {
        ...state,
        cursos: action.payload,
      };
    case ActionTypes.SET_CURSOS_COUNT:
      return {
        ...state,
        cursosCount: action.payload,
      };
    case ActionTypes.SET_SOCIEDADES_CURSOS:
      return {
        ...state,
        sociedades: action.payload,
      };
    case ActionTypes.SET_PROVINCIAS_CURSOS:
      return {
        ...state,
        provincias: action.payload,
      };
    case ActionTypes.SET_ESTADOS_CURSOS:
      return {
        ...state,
        estados: action.payload,
      };
    case ActionTypes.SET_CURSOS_FILTER:
      return {
        ...state,
        cursosFilter: action.payload,
      };
    case ActionTypes.REMOVE_CURSOS_FILTER:
      return {
        ...state,
        cursosFilter: [],
        estados: [],
        provincias: [],
        sociedades: [],
      };

    // Cursos cierre
    case ActionTypes.SET_REPORT_COURSES_CLOSING:
      return {
        ...state,
        cursosCierre: action.payload,
      };
    case ActionTypes.SET_REPORT_COURSES_CLOSING_COUNT:
      return {
        ...state,
        cursosCierreCount: action.payload,
      };
    case ActionTypes.SET_SOCIEDADES_CURSOS_CIERRES:
      return {
        ...state,
        sociedadesCursosCierres: action.payload,
      };
    case ActionTypes.SET_PROVINCIAS_CURSOS_CIERRES:
      return {
        ...state,
        provinciasCursosCierre: action.payload,
      };
    case ActionTypes.REMOVE_CURSOS_CIERRES_FILTER:
      return {
        ...state,
        sociedadesCursosCierres: [],
        provinciasCursosCierre: [],
      };
    // Caché
    case ActionTypes.SET_ALL_SOCIEDADES:
      return {
        ...state,
        allSociedades: action.payload,
      };
      //panel administracion
      //gestores
    case ActionTypes.SET_ALL_GESTORES:
      return {
        ...state,
        gestoresAll: action.payload,
      };
    case ActionTypes.SET_GET_ALL_GESTORES_REQUEST_STATUS:
      return {
        ...state,
        getAllGestoresRequestStatus: action.payload,
      };
    case ActionTypes.SET_INSERTAR_GESTORES_CURSOS_REQUEST_STATUS:
      return {
        ...state,
        insertarGestoresCursosRequestStatus: action.payload,
      };
    case ActionTypes.SET_ELIMINAR_GESTORES_CURSOS_REQUEST_STATUS:
      return {
        ...state,
        eliminarGestoresCursosRequestStatus: action.payload,
      };

    //formadores
     case ActionTypes.SET_ALL_FORMADORES:
      return {
        ...state,
        formadoresAll: action.payload,
      };
    case ActionTypes.SET_GET_ALL_FORMADORES_REQUEST_STATUS:
      return {
        ...state,
        getAllFormadoresRequestStatus: action.payload,
      };
      case ActionTypes.SET_INSERTAR_FORMADORES_CURSOS_REQUEST_STATUS:
      return {
        ...state,
        insertarFormadoresCursosRequestStatus: action.payload,
      };
    case ActionTypes.SET_ELIMINAR_FORMADORES_CURSOS_REQUEST_STATUS:
      return {
        ...state,
        eliminarFormadoresCursosRequestStatus: action.payload,
      };

     //alumnos
     case ActionTypes.SET_ALL_ALUMNOS:
      return {
        ...state,
        alumnosAll: action.payload,
      };
    case ActionTypes.SET_GET_ALL_ALUMNOS_REQUEST_STATUS:
      return {
        ...state,
        getAllAlumnosRequestStatus: action.payload,
      };
    case ActionTypes.SET_INSERTAR_ALUMNOS_CURSOS_REQUEST_STATUS:
      return {
        ...state,
        insertarAlumnosCursosRequestStatus: action.payload,
      };
    case ActionTypes.SET_ELIMINAR_ALUMNOS_CURSOS_REQUEST_STATUS:
      return {
        ...state,
        eliminarAlumnosCursosRequestStatus: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;
